export const clientDetails = [
  {
    Client_id: 0,
    label: "Title",
    value: "title",
  },
  {
    Client_id: 1,
    label: "First Name(s)",
    value: "first_names",
  },
  {
    Client_id: 2,
    label: "Initials",
    value: "initials",
  },
  {
    Client_id: 3,
    label: "Last Name",
    value: "last_name",
  },
  {
    Client_id: 4,
    label: "Former Last Name",
    value: "former_last_name",
  },
  {
    Client_id: 5,
    label: "Honours",
    value: "honours",
  },
  {
    Client_id: 6,
    label: "Known as",
    value: "known_as",
  },
  {
    Client_id: 7,
    label: "Street Address",
    value: "address_1",
  },
  {
    Client_id: 8,
    label: "Town",
    value: "town",
  },
  {
    Client_id: 9,
    label: "County",
    value: "county",
  },
  {
    Client_id: 10,
    label: "Country",
    value: "country",
  },
  {
    Client_id: 11,
    label: "Postcode",
    value: "postcode",
  },
  {
    Client_id: 12,
    label: "Home",
    value: "home_phone",
  },
  {
    Client_id: 13,
    label: "Work",
    value: "work_phone",
  },
  {
    Client_id: 14,
    label: "Fax",
    value: "fax",
  },
  {
    Client_id: 15,
    label: "Mobile",
    value: "mobile",
  },
  {
    Client_id: 16,
    label: "Email",
    value: "email",
  },
  {
    Client_id: 17,
    label: "Email (Work)",
    value: "work_email",
  },
  {
    Client_id: 18,
    label: "Date of Birth",
    value: "date_of_birth",
  },
  {
    Client_id: 19,
    label: "Age Next",
    value: "preferred_retirement_age",
  },
  {
    Client_id: 20,
    label: "NI Number",
    value: "ni_number",
  },
  {
    Client_id: 21,
    label: "Sex",
    value: "sex",
  },
  {
    Client_id: 22,
    label: "Client Type",
    value: "client_type",
  },
  {
    Client_id: 23,
    label: "Consultant",
    value: "consultant",
  },
  {
    Client_id: 24,
    label: "Administrator",
    value: "administrator",
  },
  {
    Client_id: 25,
    label: "Introduced by",
    value: "introduced_by",
  },
  {
    Client_id: 26,
    label: "Fact-find",
    value: "fact_find_completed",
  },
  {
    Client_id: 27,
    label: "Terms of Engagement",
    value: "terms_of_business_sent",
  },
  {
    Client_id: 28,
    label: "IDD",
    value: "idd",
  },

  {
    Client_id: 29,
    label: "Menu",
    value: "menu",
  },
  {
    Client_id: 30,
    label: "Data Protection",
    value: "data_protection_form_sent",
  },
  {
    Client_id: 31,
    label: "Review Interval(mths)",
    value: "review_interval",
  },
  {
    Client_id: 32,
    label: "Next Review Due",
    value: "review_date",
  },
  {
    Client_id: 33,
    label: "Review Completed",
    value: "review_completed",
  },
  {
    Client_id: 34,
    label: "Next Review Note",
    value: "review_note",
  },
  {
    Client_id: 35,
    label: "Last Updated",
    value: "last_updated",
  },
  {
    Client_id: 36,
    label: "Updated by",
    value: "updated_by",
  },
  {
    Client_id: 37,
    label: "Note",
    value: "note_text",
  },
];
